// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3qu-y","selects":"Documents_selects__3YbjM"};